import { LocalStorage } from 'libs/common';
import { Draggable } from 'libs/ui';
import { ZoneRow } from './zone-row/zone-row';
import { Content, Name, Zones } from './counter.styled';

// bumped namespace (v2) so the old scattered drag positions that overlapped the
// plan are dropped in favour of the clean single-column layout below.
const storage = new LocalStorage('counters_v2');

// left gutter of the plan is empty of devices — stack all cards there.
const PANEL_LEFT = 8;
const PANEL_TOP = 8;
const PANEL_GAP = 8;

// ширина колонки по самой широкой карточке (247 — обычная, 165 — сводная)
const CARD_W_WIDE = 247;
const CARD_W_NARROW = 165;

// высота области, в которой раскладываем карточки (низ экрана)
const getAreaHeight = () => document.querySelector('.app-content')?.clientHeight || window.innerHeight;

window.lastCounterY = PANEL_TOP;
window.lastCounterX = PANEL_LEFT;
window.lastCounterColW = 0;

export const Counter = (props) => {
  const { index, data, scale, ...rest } = props;
  const { client_name, client_id } = data;
  const wide = client_id !== 'oneTimeAll' && client_id !== 'regularAll';

  // const node = window.config.objects.zones.find((item) => {
  //   return item.zoneId.toString() === window.zone_id.toString();
  // });

  const getCoord = () => {
    const saved = storage.getItem(client_id);
    // console.log("🚀 ~ getCoord ~ saved:", saved)
    if (saved) {
      return saved;
    }
    // first card of the pass resets the running vertical offset
    if (index === 0) {
      window.lastCounterY = PANEL_TOP;
      window.lastCounterX = PANEL_LEFT;
      window.lastCounterColW = 0;
    }
    const h = data.items.length * 20 + 44; // name + padding + rows
    const w = wide ? CARD_W_WIDE : CARD_W_NARROW;
    // при достижении низа экрана переходим наверх следующего столбца
    if (window.lastCounterY > PANEL_TOP && window.lastCounterY + h > getAreaHeight() - PANEL_GAP) {
      window.lastCounterX += window.lastCounterColW + PANEL_GAP;
      window.lastCounterY = PANEL_TOP;
      window.lastCounterColW = 0;
    }
    window.lastCounterColW = Math.max(window.lastCounterColW, w);
    const x = window.lastCounterX;
    const y = window.lastCounterY;
    window.lastCounterY += h + PANEL_GAP;
    const coord = { x, y };
    storage.setItem(client_id, coord);
    return coord;
  };

  const getItemsEl = () => {
    return data.items.map((el, idx) => <ZoneRow key={idx} {...el} />);
  };

  const setCoord = (_event, el) => {
    // console.log('🚀 ~ setCoord ~ event:', el);
    const { x, y } = el;
    storage.setItem(client_id, { x, y });
  };

  const { x, y } = getCoord();
  // console.log('🚀 ~ Counter ~ x, y:', x, y, client_id);
  const itemsEl = getItemsEl();

  return (
    <Draggable defaultPosition={{ x, y }} scale={scale} onStop={setCoord} width={wide ? '247px' : '165px'}>
      <Content {...rest} style={{ width: wide ? '247px' : '165px' }}>
        <Name title={client_name}>{client_name}</Name>
        <Zones>{itemsEl}</Zones>
      </Content>
    </Draggable>
  );
};
